module.exports = __webpack_public_path__ + "static/img/email-icon.26f91e01.svg";